import http from "./http-common";

class TimeLineService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => (key && payload[key] ? key + "=" + payload[key] : ""))
      .join("&");
  }
  getTimeLineDetails(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/patientTimelineEvent/list/filter?${queryString}`);
  }

}

export default new TimeLineService();
